import { shouldIncludeAsCalendarVisitSchedule } from './shouldIncludeAsCalendarVisitSchedule';

/**
 * Business rules for determining if a padVisit should become a calendarVisit.
 * Centralizes all filtering logic for testability and reusability.
 */
export const shouldIncludeAsCalendarVisitScheduleCooperative = padVisit => {
  return !shouldIncludeAsCalendarVisitSchedule(padVisit);
};
